import {
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGOUT_USER,
    REGISTER_USER,
    REGISTER_USER_SUCCESS,
    LOGIN_USER_ERROR,
    REGISTER_USER_ERROR,
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_ERROR,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_ERROR,
    PICTURE_USER,
    USER_OFFICES,
    SET_ROL_USER,
    SET_OLD_PASS,
    USER_CONCESSIONAIRE,
    NAV_CONTENT,
    SET_EMAIL,
    SET_TOKEN_EXPIRED,
} from '../actions';

export const loginUser = (user, history) => ({
    type: LOGIN_USER,
    payload: { user, history },
});
export const loginUserSuccess = (user, token, rules, menuItems) => ({
    type: LOGIN_USER_SUCCESS,
    payload: { user, token, rules, menuItems },
});
export const loginUserError = (message) => ({
    type: LOGIN_USER_ERROR,
    payload: { message },
});

export const forgotPassword = (forgotUserMail, history) => ({
    type: FORGOT_PASSWORD,
    payload: { forgotUserMail, history },
});
export const forgotPasswordSuccess = (forgotUserMail) => ({
    type: FORGOT_PASSWORD_SUCCESS,
    payload: forgotUserMail,
});
export const forgotPasswordError = (message) => ({
    type: FORGOT_PASSWORD_ERROR,
    payload: { message },
});

export const resetPassword = ({ resetPasswordCode, newPassword, history }) => ({
    type: RESET_PASSWORD,
    payload: { resetPasswordCode, newPassword, history },
});

export const resetPasswordSuccess = (newPassword) => ({
    type: RESET_PASSWORD_SUCCESS,
    payload: newPassword,
});
export const resetPasswordError = (message) => ({
    type: RESET_PASSWORD_ERROR,
    payload: { message },
});

export const registerUser = (user, history) => ({
    type: REGISTER_USER,
    payload: { user, history },
});
export const registerUserSuccess = (user) => ({
    type: REGISTER_USER_SUCCESS,
    payload: user,
});
export const registerUserError = (message) => ({
    type: REGISTER_USER_ERROR,
    payload: { message },
});

export const logoutUser = (history) => ({
    type: LOGOUT_USER,
    payload: { history },
});
export const pictureUser = (picture) => ({
    type: PICTURE_USER,
    payload: { picture },
});
export const setDataUserOffices = (userOffices) => ({
    type: USER_OFFICES,
    payload: userOffices,
});

export const setRolUser = (codigo) => {
    localStorage.setItem('role', codigo);
    return {
        type: SET_ROL_USER,
        payload: codigo,
    };
};

export const setOldPass = (value) => {
    localStorage.setItem('oldPass', value);
    return {
        type: SET_OLD_PASS,
        payload: value,
    };
};

export const setDataUserConcessionaire = (concesionario) => ({
    type: USER_CONCESSIONAIRE,
    payload: concesionario,
});

export const setNavContent = (content) => ({
    type: NAV_CONTENT,
    payload: content,
});

export const setEmail = (email) => ({
    type: SET_EMAIL,
    payload: email,
});
export const setTokenExpired = (tokenExpired) => ({
    type: SET_TOKEN_EXPIRED,
    payload: tokenExpired,
});
